export class MeetupMinutesModel {
	virtual: number;
	physical: number;
}

export function MeetupMinutesModel_ClassTransform_Type() {
	return MeetupMinutesModel;
}
